var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIconGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26814)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000732422 4.12509C-0.000732422 2.26115 1.51029 0.750122 3.37423 0.750122L11.4422 0.750122C12.3372 0.750122 13.1957 1.1057 13.8286 1.73863L17.0106 4.92058C17.6434 5.55351 17.999 6.41195 17.999 7.30704L17.999 19.8749C17.999 21.739 16.4881 23.2499 14.6241 23.2499L3.37423 23.2499C1.51029 23.2499 -0.000732422 21.739 -0.000732422 19.8749L-0.000732422 4.12509ZM3.37423 3.0001C2.75292 3.0001 2.24924 3.50378 2.24924 4.12509L2.24924 19.8749C2.24924 20.4962 2.75292 20.9999 3.37423 20.9999L14.6241 20.9999C15.2454 20.9999 15.7491 20.4962 15.7491 19.8749L15.7491 7.30704C15.7491 7.00868 15.6304 6.72253 15.4195 6.51155L12.2377 3.3296C12.0266 3.11863 11.7405 3.0001 11.4422 3.0001L3.37423 3.0001Z",
    fill: "#27A668"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37425 3.00012C2.75295 3.00012 2.24927 3.5038 2.24927 4.12511L2.24927 19.875C2.24927 20.4963 2.75295 21 3.37425 21L14.6241 21C15.2454 21 15.7491 20.4963 15.7491 19.875L15.7491 7.30706C15.7491 7.0087 15.6305 6.72255 15.4196 6.51157L12.2377 3.32962C12.0266 3.11865 11.7406 3.00012 11.4422 3.00012L3.37425 3.00012ZM5.62423 8.62507C5.00292 8.62507 4.49924 9.12875 4.49924 9.75006C4.49924 10.3714 5.00292 10.875 5.62423 10.875L12.3741 10.875C12.9955 10.875 13.4991 10.3714 13.4991 9.75006C13.4991 9.12875 12.9955 8.62507 12.3741 8.62507L5.62423 8.62507ZM5.62423 13.125C5.00292 13.125 4.49924 13.6287 4.49924 14.25C4.49924 14.8713 5.00292 15.375 5.62423 15.375L10.1242 15.375C10.7455 15.375 11.2492 14.8713 11.2492 14.25C11.2492 13.6287 10.7455 13.125 10.1242 13.125L5.62423 13.125Z",
    fill: "#27A668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49927 14.25C4.49927 13.6287 5.00295 13.125 5.62425 13.125L10.1242 13.125C10.7455 13.125 11.2492 13.6287 11.2492 14.25C11.2492 14.8713 10.7455 15.375 10.1242 15.375L5.62425 15.375C5.00295 15.375 4.49927 14.8713 4.49927 14.25Z",
    fill: "#27A668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49927 9.74999C4.49927 9.12868 5.00295 8.625 5.62425 8.625L12.3742 8.625C12.9955 8.625 13.4992 9.12868 13.4992 9.74999C13.4992 10.3713 12.9955 10.875 12.3742 10.875L5.62425 10.875C5.00295 10.875 4.49927 10.3713 4.49927 9.74999Z",
    fill: "#27A668"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06165 11.625C5.06165 10.9001 5.64926 10.3125 6.37413 10.3125L11.6241 10.3125C12.3489 10.3125 12.9365 10.9001 12.9365 11.625L12.9365 16.8749C12.9365 17.5999 12.3489 18.1874 11.6241 18.1874L6.37413 18.1874C5.64926 18.1874 5.06165 17.5999 5.06165 16.8749L5.06165 11.625ZM6.37413 11.1875C6.13251 11.1875 5.93663 11.3834 5.93663 11.625L5.93663 16.8749C5.93663 17.1166 6.13251 17.3125 6.37413 17.3125L11.6241 17.3125C11.8657 17.3125 12.0616 17.1166 12.0616 16.8749L12.0616 11.625C12.0616 11.3834 11.8657 11.1875 11.6241 11.1875L6.37413 11.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91199 13.1125L12.9119 13.1125M5.91199 15.3875L12.9119 15.3875",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99915 10.7498L8.99915 17.7497",
    stroke: "white",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9998,
    height: 22.4998,
    fill: "white",
    transform: "translate(-0.000732422 0.750122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIconGreen);
export default __webpack_public_path__ + "static/media/ExcelIconGreen.72914a1ab4a3e698d2c1ef69d72d0648.svg";
export { ForwardRef as ReactComponent };